function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#545454",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-962 -767) translate(962 767) translate(5 3.333)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.038 7.389H3.166C1.417 7.389 0 8.807 0 10.556v12.666c0 1.75 1.417 3.167 3.166 3.167h4.678l2.859 4.766c.19.318.534.512.904.512s.713-.194.904-.512l2.859-4.766h4.678c1.749 0 3.166-1.418 3.166-3.167V20.9c5.313-1.079 8.943-6.01 8.399-11.405-.545-5.396-5.088-9.5-10.51-9.495-4.605.006-8.677 2.995-10.065 7.389zm10.066 15.833c0 .583-.473 1.056-1.056 1.056h-5.275c-.37 0-.714.194-.905.512l-2.261 3.77-2.261-3.77c-.191-.318-.534-.512-.905-.512H3.166c-.583 0-1.056-.473-1.056-1.056V10.556c0-.583.473-1.056 1.056-1.056h7.44c-.301 2.969.669 5.926 2.67 8.14 2 2.212 4.845 3.474 7.828 3.471v2.111zm0-4.222c-4.662 0-8.442-3.78-8.442-8.444 0-4.664 3.78-8.445 8.442-8.445 4.662 0 8.441 3.78 8.441 8.445-.005 4.661-3.781 8.439-8.441 8.444z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.375 3.483c-2.186 0-3.958 1.595-3.958 3.563 0 .656.59 1.187 1.32 1.187.728 0 1.319-.531 1.319-1.187s.59-1.188 1.319-1.188 1.32.532 1.32 1.188c0 .667-.287.95-.933 1.535-1.067.794-1.691 1.97-1.706 3.215 0 .656.59 1.187 1.319 1.187s1.32-.531 1.32-1.187c0-.668.286-.95.932-1.536 1.067-.793 1.691-1.969 1.706-3.214 0-1.968-1.772-3.563-3.958-3.563z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21.375,
  cy: 15.2,
  r: 1.583
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.354 14.25H6.73c.656 0 1.188-.354 1.188-.792 0-.437-.532-.791-1.188-.791H4.354c-.656 0-1.187.354-1.187.791 0 .438.531.792 1.187.792zM4.117 17.417h2.85c.524 0 .95-.355.95-.792 0-.437-.426-.792-.95-.792h-2.85c-.525 0-.95.355-.95.792 0 .437.425.792.95.792zM10.094 19H4.156c-.546 0-.99.354-.99.792 0 .437.444.791.99.791h5.938c.546 0 .99-.354.99-.791 0-.438-.444-.792-.99-.792z"
})))));

var SvgIconQuestionCount = function SvgIconQuestionCount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconQuestionCount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-question-count.a5857dc8.svg";
export { ForwardRef as ReactComponent };